import { ForwardedRef, forwardRef } from 'react';

import { Select } from '@xemplo/base-multi-select';
import { V2, V2Types } from '@xemplo/popover';
import { List } from '@xemplo/stateful-list';

import { useTagField } from './hooks/use-tag-field';
import { TagFieldProps } from './tag-field.types';

export const TagField = forwardRef(
  (props: TagFieldProps, ref?: ForwardedRef<HTMLDivElement>) => {
    const { popoverRef, selectProps, listProps } = useTagField(props);

    return (
      <V2.Popover.Root
        ref={popoverRef}
        trigger={V2Types.PopoverTrigger.Click}
        onOpenChange={props.onOpenChange}
      >
        <V2.Popover.Trigger>
          {({ open }) => <Select {...selectProps} ref={ref} open={open} />}
        </V2.Popover.Trigger>
        <V2.Popover.Popup>
          <List.TagsSelect {...listProps} />
        </V2.Popover.Popup>
      </V2.Popover.Root>
    );
  }
);

export default TagField;
